import { IScheduleSectionFormValues } from '@src/features/shift-post-v2/steps/shift-details-step/components/schedule-section/schedule-section.types'
import { setNumberTo2DecimalsOnly } from 'helpers/numberHelpers'
import { updateDays } from 'ui/components/Admin/Shifts/ShiftEditDuplicate/utils'
import { FormikProps } from 'formik'

export const handlePayRateChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  formik: FormikProps<IScheduleSectionFormValues>
) => {
  const { setValues, values } = formik

  const payValue = setNumberTo2DecimalsOnly(e.target.value)
  const days = updateDays(values.days, {
    pay_value: payValue,
  })

  const updatedShifts = values.single_day_shifts?.map((shift) => ({
    ...shift,
    pay_value: payValue,
  }))

  setValues({
    ...values,
    pay_value: payValue || '',
    days,
    single_day_shifts: updatedShifts,
  })
}
